export default function updateBundlePricing(api) {
  // TODO: to config
  const bundleFields = [
    'weightedProfessional',
    'weightedTechnical',
    'weightedGlobal',
  ];

  return bundleFields.reduce((acc, field) => {
    const valueGetter = api.getColumnDef(field).valueGetter;

    return Object.assign(
      {},
      acc,
      {
        [field]: Intl.NumberFormat(
          'en-US', { style: 'currency', currency: 'USD' }
        ).format(api.rowModel.rowsToDisplay.reduce(
          (acc1, { data }) => acc1 + valueGetter({ api, data }), 0
        )),
      }
    );
  }, {});
}



// WEBPACK FOOTER //
// ./app/services/updateBundledPricing.js